import {
  avatarUniquenessRequest,
  avatarsRequest,
  fetchAccessRequest,
  fetchAllEmployeesInStore,
  fetchAllStoresDetails,
  fetchAppCustomersData,
  fetchAreaBreakdownData,
  fetchAreaComparisonData,
  fetchAveragePiecesPerReceiptData,
  fetchBopisData,
  fetchBudgetPlanOverviewData,
  fetchChatBotData,
  fetchConversionRateOverviewData,
  fetchConversionRateWidgetData,
  fetchCurrencyConversionData,
  fetchCustomerBaseValueViewData,
  fetchCustomerEngagementData,
  fetchCustomerExperienceViewData,
  fetchCustomerFeedbackData,
  fetchEffectiveHoursBudget,
  fetchEfficiencyOverviewData,
  fetchForecastForKpis,
  fetchHelpASaleData,
  fetchKpiOverviewData,
  fetchKpiTargets,
  fetchKpisAreaDetails,
  fetchLastKpi,
  fetchMemberOverviewData,
  fetchMessageData,
  fetchNetSalesBudget,
  fetchNewMembers,
  fetchORISData,
  fetchPermissions,
  fetchProductIndex,
  fetchProfitLossData,
  fetchQueueCustomerOverviewData,
  fetchQueueLengthData,
  fetchReceiptSalesAnalysisData,
  fetchRequestedAssignments,
  fetchRfidCountData,
  fetchRoleMatrix,
  fetchSCOShareOfReceiptsData,
  fetchSalesAnalysisData,
  fetchSalesEfficiencyViewData,
  fetchSalesInsightsData,
  fetchSalesNetPerReceiptData,
  fetchSalesNetWidgetData,
  fetchSalesOverviewData,
  fetchSalesPerformanceData,
  fetchShareOfReceipts,
  fetchSoldProductsPage,
  fetchSptBudget,
  fetchStoreData,
  fetchStoreDetails,
  fetchSummaryWidgetsData,
  fetchTakt1Budget,
  fetchTopSellingGarmentData,
  fetchVisitorsBudget,
  fetchWeatherWidgetData,
  fetchWeeklyTopPlannedProductsData,
  fetchWeeklyTopSoldProductsData,
  getBlacklistPermissionsData,
  mockFetchBopisLeadTimeData,
  mockFetchRfidOverviewData,
  mockFetchStockAccuracyData,
  mockRfidApprovalsData,
  mockRfidSalesRetaggingData,
  mockStockInventoryCount,
  postBlacklistPermissionsData,
  profileByUpnRequest,
  receiptRequest,
  transactionCountRequest,
  transactionRequest,
  updateProfileRequest,
  userAccessRequestData,
} from './handlers';

export const browserHandlers = [
  // User
  // profileByUpnRequest({ addDelay: true, isAvatarAssigned: false }),
  // fetchPermissions(true),
  // fetchRoleMatrix(true),
  // getBlacklistPermissionsData(true),
  // postBlacklistPermissionsData(true),
  //
  // User Access
  // userAccessRequestData(true),
  // fetchAccessRequest(true),
  // fetchRequestedAssignments(true),
  //
  // Store
  // fetchAllStoresDetails(true),
  // fetchStoreDetails(true),
  // fetchStoreData(true), // This does not reflect the mocks as expected, change the data in dev database to check the changes.
  //
  // CurrencyConversion
  // fetchCurrencyConversionData(true),
  //
  // Avatar
  // avatarsRequest(true),
  // avatarUniquenessRequest(true),
  //
  // Transactions
  // transactionRequest(true),
  // transactionCountRequest(true, 500),
  // receiptRequest(true),
  //
  // Employees
  // fetchAllEmployeesInStore(true),
  // updateProfileRequest(true),
  //
  // KPI
  // fetchKpisAreaDetails(true),
  // fetchKpiTargets(true),
  // fetchLastKpi(true),
  //
  // Budget
  // fetchNetSalesBudget(true),
  // fetchEffectiveHoursBudget(true),
  // fetchTakt1Budget(true),
  // fetchSptBudget(true),
  // fetchVisitorsBudget(true),
  //
  // Widgets
  // fetchHourlyTurnoverWidgetData(true),
  // fetchSalesNetWidgetData(true),
  // fetchSCOHourlyTurnoverWidgetData(true),
  // fetchConversionRateWidgetData(true),
  // fetchWeatherWidgetData(true),
  // fetchTopSellingGarmentData(true),
  // fetchShareOfReceipts(true),
  // fetchSCOShareOfReceiptsData(true),
  // fetchNewMembers(true),
  // fetchAppCustomersData(true),
  // fetchSalesNetPerReceiptData(true),
  // fetchAveragePiecesPerReceiptData(true),
  // fetchQueueLengthData(true),
  // fetchForecastForKpis(true),
  // fetchReceiptSalesAnalysisData(true),
  // fetchAreaComparisonData(true),
  // fetchCustomerFeedbackData(true),
  // fetchORISData(true),
  // fetchCustomerEngagementData(true),
  // fetchSalesInsightsData(true),
  // fetchHelpASaleData(true),
  //
  // Store Overview Widgets
  // fetchSalesPerformanceData(true),
  // fetchWeeklyTopSoldProductsData(true),
  // fetchWeeklyTopPlannedProductsData(true),
  //
  // Area Overview Widgets
  // fetchSalesOverviewData(true),
  // fetchConversionRateOverviewData(true),
  // fetchEfficiencyOverviewData(true),
  // fetchMemberOverviewData(true),
  // mockFetchRfidOverviewData(true),
  // fetchQueueCustomerOverviewData(true),
  // fetchBudgetPlanOverviewData(true),
  // fetchKpiOverviewData(true),
  // fetchSummaryWidgetsData(true),
  // fetchAreaBreakdownData(true),
  //
  // Area Result
  // fetchCustomerBaseValueViewData(true),
  // fetchSalesEfficiencyViewData(true),
  // fetchCustomerExperienceViewData(true),
  //
  // RFID
  // fetchRfidCountData(true),
  // mockRfidApprovalsData(true),
  // mockRfidSalesRetaggingData(true),
  // mockStockInventoryCount(true),
  // mockFetchStockAccuracyData(true),
  // fetchBopisData(true),
  // mockFetchBopisLeadTimeData(true),
  //
  // Sold Products
  // fetchSoldProductsPage(true),
  // fetchProductIndex(true),
  //
  // Sales Analysis
  // fetchSalesAnalysisData(true),
  //
  // Profit and Loss
  // fetchProfitLossData(true),
  //
  // Misc
  // fetchMessageData(true),
  // fetchChatBotData(true),
];

export const serverHandlers = [
  // User
  profileByUpnRequest({}),
  fetchPermissions(),
  fetchRoleMatrix(),

  getBlacklistPermissionsData(),
  postBlacklistPermissionsData(),

  // User Access
  userAccessRequestData(),
  fetchAccessRequest(),
  fetchRequestedAssignments(),

  // Store
  fetchAllStoresDetails(),
  fetchStoreDetails(),
  fetchStoreData(),

  // CurrencyConversion
  fetchCurrencyConversionData(),

  // Avatar
  avatarsRequest(),
  avatarUniquenessRequest(),

  // Transactions
  transactionRequest(),
  transactionCountRequest(),
  receiptRequest(),

  // Employees
  fetchAllEmployeesInStore(undefined, true),
  updateProfileRequest(),

  // KPI
  fetchKpisAreaDetails(),
  fetchKpiTargets(),
  fetchLastKpi(),

  // Budget
  fetchNetSalesBudget(),
  fetchEffectiveHoursBudget(),
  fetchTakt1Budget(),
  fetchSptBudget(),
  fetchVisitorsBudget(),

  // Widgets
  fetchSalesNetWidgetData(),
  fetchConversionRateWidgetData(),
  fetchWeatherWidgetData(),
  fetchTopSellingGarmentData(),
  fetchShareOfReceipts(),
  fetchSCOShareOfReceiptsData(),
  fetchNewMembers(),
  fetchAppCustomersData(),
  fetchSalesNetPerReceiptData(),
  fetchAveragePiecesPerReceiptData(),
  fetchQueueLengthData(),
  fetchForecastForKpis(),
  fetchReceiptSalesAnalysisData(),
  fetchAreaComparisonData(),
  fetchCustomerFeedbackData(),
  fetchORISData(),
  fetchCustomerEngagementData(),
  fetchSalesInsightsData(),
  fetchHelpASaleData(),

  // Store Overview Widgets
  fetchSalesPerformanceData(),
  fetchWeeklyTopSoldProductsData(),
  fetchWeeklyTopPlannedProductsData(),

  // Area Overview Widgets
  fetchSalesOverviewData(),
  fetchConversionRateOverviewData(),
  fetchEfficiencyOverviewData(),
  fetchMemberOverviewData(),
  mockFetchRfidOverviewData(),
  fetchQueueCustomerOverviewData(),
  fetchBudgetPlanOverviewData(),
  fetchKpiOverviewData(),
  fetchSummaryWidgetsData(),
  fetchAreaBreakdownData(),

  // Area Result
  fetchCustomerBaseValueViewData(),
  fetchSalesEfficiencyViewData(),
  fetchCustomerExperienceViewData(),

  // RFID
  fetchRfidCountData(),
  mockRfidApprovalsData(),
  mockRfidSalesRetaggingData(),
  mockStockInventoryCount(),
  mockFetchStockAccuracyData(),
  fetchBopisData(),
  mockFetchBopisLeadTimeData(),

  // Sold Products
  fetchSoldProductsPage(),
  fetchProductIndex(),

  // Sales Analysis
  fetchSalesAnalysisData(),

  // Profit and Loss
  fetchProfitLossData(),

  // Misc
  fetchMessageData(),
  fetchChatBotData(),
];
